<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part01">
<div class="partHead" id="ph01">
<a id="page27"></a>
<h2 class="partNumber" style="text-indent: 0%;"><span class="xrefInternal"><a href="#/004TOC#part_01"><span class="bold">One</span></a></span></h2>
<h2 class="partTitle" style="text-indent: 0%;"><span class="bold">THE WORLD THAT JOHNSON KNEW</span></h2></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006-part01.vue?7aeba88e